import { render } from "./AlterarFase.vue?vue&type=template&id=22308067"
import script from "./AlterarFase.vue?vue&type=script&lang=js"
export * from "./AlterarFase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__